const europeanCountries = [
  'AT', 'BE', 'BG', 'CY', 'CZ', 'DE', 'DK', 'EE', 'ES', 'FI',
  'FR', 'GB', 'GR', 'HR', 'HU', 'IE', 'IT', 'LT', 'LU', 'LV',
  'MT', 'NL', 'PL', 'PT', 'RO', 'SE', 'SI', 'SK',
  'CH', 'NO', 'IS', 'LI', 'AL', 'AD', 'BA', 'BY', 'FO', 'GI',
  'IM', 'JE', 'GG', 'MC', 'MD', 'ME', 'MK', 'RS', 'SM', 'UA',
  'VA', 'XK', 'RU', 'TR',
]

const countryIsInEurope = country =>
  Boolean(country) && europeanCountries.includes(country.toUpperCase())

export default countryIsInEurope
